import {Component, OnInit, signal, effect} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NewOrderModal } from './new-order-modal/new-order-modal';
import { NgClass, NgOptimizedImage, CommonModule } from "@angular/common";
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ITEMS_PER_PAGE } from '../core/config/pagination.constants';
import { IOrder, IOrderList } from '../shared/model/order.model';
import { PaginatorState } from 'primeng/paginator';
import { SpinnerOverlayService } from '../Components/spinner/spinner-overlay.service';
import { OrderService, EntityArrayResponseType } from './order-service';
import { STATUS } from '../core/config/order-status.constants';
import { FormsModule } from '@angular/forms';
import { CustomInput } from '../Components/input/custom-input';
import { Button } from '../Components/button/button';
import { CustomerService, EntityResponseType as CreditTermsResponseType } from '../shared/service/customer-service';
import { AccountService } from '../login/account.service';
import { OrderUtilsService } from './shared/order-utils.service';
import { OrderDetailDialog } from './order-detail-dialog/order-detail-dialog';
import { WarehouseService } from '../shared/service/warehouse-service';
import { ROLE_BUYER, ROLE_OWNER, ROLE_ADMIN, ROLE_MANAGER } from '../core/config/role.constants';
import { ConfirmDeleteDialog } from './confirm-delete-dialog/confirm-delete-dialog';
import {IWarehouse} from '../shared/model/warehouse.model';
import { ProductCartService } from './product-cart-component/product-cart-service';
import { WarehouseSelectionDialog } from './warehouse-selection-dialog/warehouse-selection-dialog';
@Component({
  selector: 'app-orders',
  imports: [
    CommonModule,
    NgOptimizedImage,
    TableModule,
    NgClass,
    FormsModule,
    CustomInput,
    Button
  ],
  templateUrl: './orders.html',
  styleUrl: './orders.css'
})
export class Orders implements OnInit {
  assignedWarehouseCode: string | null = null;
  isComprador: boolean = false;
  canCreateOrder: boolean = false;
  isOnlyOwner: boolean = false;
  totalOrders: number = 100
  totalOrdersValue: number = 682.50
  lastOrderDate: String = ""
  creditLimit: number = 0
  orderList: IOrder[] = []
  totalItems: number = 0
  rows = ITEMS_PER_PAGE;
  first = 0;
  page = 0;
  sortField = "created_at";
  sortOrder = 0;
  lastEvent: any;
  orderStatusList = Object.entries(STATUS).map(([key, value]) => ({ key, value }));
  orderNumber: string | null = null
  fechaDesde: string | null = null;
  fechaHasta: string | null = null;
  status: string | null = null;
  isOwner: boolean = false;
  showTabs: boolean = false;
  activeTab: 'MINE' | 'ALL' = 'MINE';


  constructor(
    private dialog: MatDialog,
    private spinner: SpinnerOverlayService,
    private orderService: OrderService,
    private customerService: CustomerService,
    private accountService: AccountService,
    private router: Router,
    private orderUtils: OrderUtilsService,
    private warehouseService: WarehouseService,
    private productCartService: ProductCartService
  ) {
    this.lastOrderDate = this.formatToDDMMYYYY(new Date())

    effect(() => {
      const selectedCode = this.accountService.selectedWarehouseCode();
      if (selectedCode && selectedCode !== this.assignedWarehouseCode && this.canCreateOrder) {
        this.assignedWarehouseCode = selectedCode;
        this.findAll(true);
      }
    });
  }

  ngOnInit() {
    this.checkUserRoleAndWarehouse();
    const addressNumber = this.accountService.userIdentity()?.user.addressNumber;
    if (addressNumber) {
      this.getCreditTermsByAddressNumber()
    }

    localStorage.removeItem('orderId');
    localStorage.removeItem('my_cart_items');
    localStorage.removeItem('orderItems');
    localStorage.removeItem('orderNumber');
    this.productCartService.clearCart(); 
  }

  checkUserRoleAndWarehouse() {
    const user = this.accountService.userIdentity()?.user;
    const warehouseCodes = this.accountService.warehouseCodes();
    const selectedCode = this.accountService.selectedWarehouseCode();
    
    this.isOwner = this.accountService.hasAnyAuthority(ROLE_OWNER);
    this.canCreateOrder = this.accountService.hasAnyAuthority(ROLE_BUYER);
    this.showTabs = this.isOwner && this.canCreateOrder;

    if (this.showTabs) {
      this.activeTab = 'MINE';
      this.status = null;
    } else if (this.isOwner) {
      this.activeTab = 'ALL';
      this.status = 'CONFIRMED';
    } else {
      this.activeTab = 'MINE';
      this.status = null;
    }
    
    const hasOtherRoles = this.accountService.hasAnyAuthority(ROLE_BUYER) ||
                          this.accountService.hasAnyAuthority(ROLE_ADMIN) ||
                          this.accountService.hasAnyAuthority(ROLE_MANAGER);
    this.isOnlyOwner = this.isOwner && !hasOtherRoles;

    if (this.canCreateOrder && warehouseCodes.length > 0) {
      if (selectedCode && warehouseCodes.includes(selectedCode)) {
        this.assignedWarehouseCode = selectedCode;
        this.findAll();
        this.loadInvoicedSummary();
      } else {
        this.openWarehouseSelectionDialog(warehouseCodes);
      }
    } else {
      this.findAll();
      this.loadInvoicedSummary();
    }
  }

  openWarehouseSelectionDialog(warehouseCodes: string[]) {
    this.dialog.open(WarehouseSelectionDialog, {
      width: '500px',
      maxWidth: '90vw',
      data: { warehouseCodes },
      panelClass: 'lexend-dialog',
      disableClose: true
    }).afterClosed().subscribe((selectedCode: string) => {
      if (selectedCode) {
        this.accountService.updateSelectedWarehouse(selectedCode);
        this.assignedWarehouseCode = selectedCode;
        this.findAll();
        this.loadInvoicedSummary();
      }
    });
  }

  switchTab(tab: 'MINE' | 'ALL') {
    if (this.activeTab !== tab) {
      this.activeTab = tab;

      if (tab === 'ALL' && this.showTabs) {
         this.status = 'CONFIRMED';
      } else {
         this.status = null;
      }
      
      this.cleanFilter(true);
    }
  }
  openOrderModal() {
    localStorage.removeItem('orderId');
    localStorage.removeItem('my_cart_items');
    localStorage.removeItem('orderItems');
    localStorage.removeItem('orderNumber');
    this.productCartService.clearCart(); 
    this.dialog.open(NewOrderModal, {
      width: '25vw',
      height: 'auto',
      minWidth: '400px',
      maxWidth: '900px',
      maxHeight: '90vh',
      panelClass: 'lexend-dialog',
      disableClose: true
    });
  }

  formatToDDMMYYYY(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  onPageChange(event: PaginatorState) {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? 10;
    this.page = Math.floor((this.first ?? 0) / (this.rows ?? 10));
    this.findAll();
  }

  handleLoading(loading: boolean) {
    if (loading) this.spinner.show(); else this.spinner.hide()
  }

  findAll(reset: boolean = false) {
    this.handleLoading(true);

    if (reset) {
      this.sortField = 'created_at';
      this.sortOrder = 0;
    }
    const params: any = {
      page: reset ? 0 : this.page,
      size: this.rows,
      sort: `${this.sortField},${this.sortOrder === 1 ? 'asc' : 'desc'}`,
      order_number: this.orderNumber ?? null,
      status: this.status ?? null
    };

    if (this.fechaDesde) params.dateFrom = this.fechaDesde;
    if (this.fechaHasta) params.dateTo = this.fechaHasta;

    const user = this.accountService.userIdentity()?.user;
    
    if (this.activeTab === 'MINE') {
      if (this.canCreateOrder && this.assignedWarehouseCode) {
        params.warehouseCode = this.assignedWarehouseCode;
      } else if (user?.id) {
        params.userId = user.id;
      }
    } else if (this.activeTab === 'ALL' && user?.addressNumber) {
      params.customerAN = user.addressNumber;
    }


    this.orderService.findByParams(params).subscribe({
      next: (response: EntityArrayResponseType) => {
        this.orderList = response.body?.order.order ?? [];
        this.totalItems = response.body?.order.totalCount ?? 0;
        this.loadInvoicedSummary(); 
        this.handleLoading(false);
      },
      error: () => {
        this.handleLoading(false);
      }
    });
  }

  loadOrders(event: TableLazyLoadEvent) {
    if (JSON.stringify(event) === JSON.stringify(this.lastEvent)) {
      return;
    }
    this.lastEvent = event;

    this.sortField = Array.isArray(event.sortField) ? event.sortField[0] : event.sortField ?? 'startDate';
    this.sortOrder = event.sortOrder ?? 1;
    this.page = Math.floor((event.first ?? 0) / (event.rows ?? 10));
    this.rows = event.rows ?? 10;

    this.findAll();
  }

  getBackgroundClasses(status: string) {
    const s = (status ?? '').toString().toUpperCase();
    switch (s) {
      case 'CONFIRMED':
        return 'bg-green-100 text-green-800';
      case 'DRAFT':
        return 'bg-rose-100 text-rose-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  getStatusLabel(status: string) {
    const s = (status ?? '').toString().toUpperCase();
    switch (s) {
      case 'CONFIRMED':
        return 'Confirmado';
      case 'DRAFT':
        return 'En borrador';
      default:
        return status ?? '-';
    }
  }

  isEditable(status: string) {
    return (status ?? '').toString().toUpperCase() === 'DRAFT' && 
           this.canCreateOrder && 
           this.activeTab === 'MINE';
  }

  isInvoiced(status: string) {
    return (status ?? '').toString().toUpperCase() === 'CONFIRMED';
  }

  openOrderDetailDialog(order: IOrder) {
    if (!order) return;

    this.dialog.open(OrderDetailDialog, {
      width: '80vw',
      maxWidth: '1300px',
      data: order,
      panelClass: 'lexend-dialog'
    });
  }

  getCreditTermsByAddressNumber() {
    this.handleLoading(true);

    const addressNumber = this.accountService.userIdentity()?.user.addressNumber

    this.customerService.getCreditTermsByAddressNumber(addressNumber).subscribe({
      next: (response: CreditTermsResponseType) => {
        this.creditLimit = response.body?.customer.creditLimit ?? 0;
        this.handleLoading(false);
      },
      error: () => {
        this.handleLoading(false);
      }
    })

  }

  loadInvoicedSummary() {
    const params: any = {};
    const user = this.accountService.userIdentity()?.user;

    if (this.fechaDesde) params.dateFrom = this.fechaDesde;
    if (this.fechaHasta) params.dateTo = this.fechaHasta;

    if (this.activeTab === 'MINE') {
      if (this.canCreateOrder && this.assignedWarehouseCode) {
        params.warehouseCode = this.assignedWarehouseCode;
      } else if (user?.id) {
        params.userId = user.id;
      }
    } else if (this.activeTab === 'ALL' && user?.addressNumber) {
      params.customerAN = user.addressNumber;
    }

    this.orderService.getInvoicedOrdersSummary(params).subscribe({
      next: (summary: any) => {
        try {
          this.totalOrders = summary?.totalOrders ?? 0;
          this.totalOrdersValue = summary?.totalValue ?? 0;
          const last = summary?.lastOrderDate ?? null;
          this.lastOrderDate = last ? this.formatToDDMMYYYY(new Date(last)) : '-';
        } catch (e) {
          console.error('Failed to apply invoiced summary', e);
        }
      },
      error: (err) => {
        console.error('Error loading invoiced summary', err);
      }
    });
  }

  downloadOrderExcel(orderNumber: string) {
    this.orderUtils.downloadOrderExcel(orderNumber)
  }

  viewOrderItems(orderId: string | number) {
    if (!orderId) return;

    this.handleLoading(true);
    const addressNumber = this.accountService.userIdentity()?.user.addressNumber;

    this.orderService.getOrderItems(String(orderId), addressNumber, addressNumber).subscribe({
      next: (response: any) => {
        try {
          const itemsArray = response?.body?.items ?? response?.items ?? response;
          localStorage.setItem('orderId', String(orderId));
          localStorage.setItem('my_cart_items', JSON.stringify(itemsArray));
        } catch (e) {
          console.error('Failed to save order items to localStorage', e);
        }
        this.handleLoading(false);
        this.router.navigate(['/home/pedidos/crear/confirmar-pedido']);
      },
      error: () => {
        this.handleLoading(false);
      }
    })
  }

  deleteOrder(order: IOrder) {
    if (!order.id) return;
    const identifier = order.orderNumber || order.id;

    const dialogRef = this.dialog.open(ConfirmDeleteDialog, {
      width: '400px',
      data: { identifier: identifier },
      panelClass: 'lexend-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.handleLoading(true);
        this.orderService.deleteOrder(order.id!).subscribe({
          next: () => {
            this.findAll(true);
          },
          error: (err) => {
            console.error('Error al eliminar el pedido', err);
            this.handleLoading(false);
          }
        });
      }
    });
  }

  cleanFilter(preserveTab: boolean = false) {
    this.orderNumber = null;
    this.fechaDesde = null;
    this.fechaHasta = null;
    if (!preserveTab) {
       this.status = (this.isOnlyOwner) ? 'CONFIRMED' : null;
       if (this.showTabs) this.activeTab = 'MINE';
    }
    this.findAll(true);
  }

}
